import { render, staticRenderFns } from "./GreenChillyExtract.vue?vue&type=template&id=0568a7a0&scoped=true&"
import script from "./GreenChillyExtract.vue?vue&type=script&lang=js&"
export * from "./GreenChillyExtract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0568a7a0",
  null
  
)

export default component.exports